import React from 'react';

import LandingSector from '../../components/Inicio/LandingSector';
import SecondSector from '../../components/Inicio/SecondSector';
import ThirdSector from '../../components/Inicio/ThirdSector';
import FourthSector from '../../components/Inicio/FourthSector';
import NewsFAQ from '../../components/Inicio/NewsFAQ';


const Inicio = () => {
  return (
      <main className='inicio-section-body'>
        <section id="landing-section">
            <LandingSector />
        </section>
        <section id="second-section">
            <SecondSector />
        </section>
        <section id="third-section">
            <ThirdSector />
        </section>
        <section id="fourth-section">
            <FourthSector />
        </section>
        <section id="newsfaq-section">
            <NewsFAQ />
        </section>
      </main>
  );
};

export default Inicio;